import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import { Suspense } from "react";
import type { QueryClient } from "@tanstack/react-query";

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: () => (
    <div className="container mx-auto py-24 text-center">
      <h1 className="font-serif text-4xl text-palm">Not found</h1>
      <p className="mt-2 text-muted-foreground">That page wandered off into the cenote.</p>
    </div>
  ),
});

function RootComponent() {
  return (
    <>
      <Outlet />
      <Suspense>
        {import.meta.env.DEV ? <TanStackRouterDevtools position="bottom-right" /> : null}
      </Suspense>
    </>
  );
}
